// import spinner from '../components/spinner'; // used in extended components
// import scrollUtils from '../utils/scrollUtils'; // used in extended components
import customEventBus from '../libs/eventBus'; // used in extended components
import queryString from 'query-string';
import analyticsUtils from '../utilities/analyticsUtils';
import BaseComponent from '../base/baseComponent';
import buildAddToCartButton from '../utilities/buildAddToCartButton';
import fillWishlistHeart from '../utilities/fillWishlistHeart';
export default class ProductSearchComponent extends BaseComponent {
    constructor(element) {
        super(element);
        /* class vars */
        // spinner = spinner;
        // scroll = scrollUtils;
        this.customEventBus = customEventBus;
        // analytics = analyticsUtils;
        this.qs = queryString;
        this.selectors = {
            productListWrapper: '.product-grid',
            product: '.product-tile',
            siblingsTotal: '.combo-toolbarsiblings-counter',
            pagination: '.productgrid-pagination',
            paginationCounter: '.productgrid-pagination-counter-part',
            paginationProgress: '.productgrid-pagination-progressbar-value',
            paginationTotal: '.productgrid-pagination-counter-count',
            refinmentProductsTotal: '.search-results-info-counter',
        };
        this.waiting = false;
        this.endpoint = '';
        this.categoryurl = document.querySelector(this.selectors.productListWrapper).getAttribute('data-categoryurl') || '';
        if (!window.productSearchData) {
            throw Error(`ProductSearchComponent: window.productSearchData not declared in static.ts`);
        }
        if (!document.querySelector(this.selectors.productListWrapper)) {
            throw Error(`ProductSearchComponent: ${this.selectors.productlistWrapper} not found`);
        }
        //  
        this.setInitCount();
        this.setInitParameters();
        this.reviewPaginationCta();
    }
    setInitCount() {
        window.productSearchData.counter = document.querySelector(this.selectors.productListWrapper).querySelectorAll(this.selectors.product).length || 0;
        window.productSearchData.increment = parseInt(document.body.querySelector(this.selectors.productListWrapper).getAttribute('data-paginationsize')) || 12;
        window.productSearchData.total = parseInt(document.querySelector(this.selectors.productListWrapper).getAttribute('data-productcount'));
        window.productSearchData.datalayerOffset = 1;
    }
    setInitParameters() {
        window.productSearchData.searchParams = window.productSearchData.searchParams || this.qs.parse(document.querySelector(this.selectors.productListWrapper).getAttribute('data-querystring')) || {};
        window.productSearchData.searchParams.sz = window.productSearchData.searchParams.sz || window.productSearchData.increment;
        window.productSearchData.searchQs = window.productSearchData.searchQs || {};
    }
    async getPage(targetEvent) {
        if (this.waiting === false) {
            this.waiting = true;
            targetEvent.classList.add('loading');
            try {
                const data = await this.getFetchedDom(`${this.endpoint}?${this.qs.stringify(window.productSearchData.searchParams)}`);
                this.parseResults(data);
                targetEvent.classList.remove('loading');
            }
            catch (ev) {
                console.error(ev);
                targetEvent.classList.remove('loading');
            }
            finally {
                this.waiting = false;
                targetEvent.classList.remove('loading');
            }
        }
    }
    async getFetchedDom(url) {
        return fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function (response) {
            return response.text();
        });
    }
    parseResults(data) {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        if (this.printMethod === 'replace') {
            // refinements - sorting
            this.reviewDomElements(html);
            document.body.querySelector(this.selectors.productListWrapper).innerHTML = html.querySelector(this.selectors.productListWrapper).innerHTML;
            // scrollUtils.toTop();
        }
        else {
            // pagination
            document.body.querySelector(this.selectors.productListWrapper).insertAdjacentHTML('beforeend', html.body.querySelector(this.selectors.productListWrapper).innerHTML);
        }
        this.updateData(html);
        buildAddToCartButton();
        fillWishlistHeart();
        this.updatePageCounter();
        this.reviewPaginationCta();
        this.pushUrlState();
        if (this.printMethod === 'replace') {
            this.updatePageCounter();
            this.reviewPaginationCta();
        }
        // analytics
        this.prepareDatalayer(html.body.querySelector(this.selectors.productListWrapper));
    }
    reviewDomElements(html) {
        // to override in child class - refinements
    }
    updatePageCounter() {
        const refinementsTotals = document.body.querySelectorAll(this.selectors.refinmentProductsTotal);
        if (refinementsTotals) {
            refinementsTotals.forEach(function (refinementsTotal) {
                let singleLabel = refinementsTotal.querySelector('.label-single');
                let multipleLabel = refinementsTotal.querySelector('.label-multiple');
                if (window.productSearchData.total === 1) {
                    multipleLabel.classList.add('d-none');
                    singleLabel.classList.remove('d-none');
                }
                else {
                    singleLabel.classList.add('d-none');
                    multipleLabel.classList.remove('d-none');
                }
                refinementsTotal.querySelector('.counter').innerHTML = window.productSearchData.total.toString();
                const refinmentProductsItems = refinementsTotal.parentElement.querySelector('.search-results-info-counter-items');
                if (refinmentProductsItems && refinmentProductsItems.dataset.item && refinmentProductsItems.dataset.items) {
                    refinmentProductsItems.innerHTML = window.productSearchData.total == 1 ? refinmentProductsItems.dataset.item : refinmentProductsItems.dataset.items;
                }
            });
        }
        document.body.querySelector(this.selectors.productListWrapper).setAttribute('data-productcount', window.productSearchData.total.toString());
    }
    updateData(html) {
        // to override in child class
    }
    reviewPaginationCta() {
        let paginationHTML = document.body.querySelector(this.selectors.pagination);
        if (window.productSearchData.counter >= window.productSearchData.total) {
            paginationHTML.style.display = 'none';
        }
        else {
            paginationHTML.removeAttribute('style');
        }
    }
    pushUrlState() {
        window.history.replaceState('', '', `${this.categoryurl && this.categoryurl !== '' && this.categoryurl !== 'null' ? this.categoryurl : (window.location.origin + window.location.pathname)}?${this.qs.stringify(window.productSearchData.searchQs)}`);
    }
    async prepareDatalayer(context) {
        let tile = context.querySelector(this.selectors.product);
        let data = {
            'forcedPipeline': 'ProductImpressions',
            'pids': analyticsUtils.getListPids(context),
            'item_list_name': analyticsUtils.getTileListName(tile),
            'offset': (window.productSearchData.datalayerOffset).toString(),
        };
        analyticsUtils.passThroughProcessor(data);
    }
}
